import {
    MetaComponent as SourceMetaComponent,
} from 'SourceComponent/Meta/Meta.component';
import React, { Fragment } from 'react';
import './Meta.override.style';

export class MetaComponent extends SourceMetaComponent {
    renderTitle() {
        const {
            default_title,
            title_prefix,
            title_suffix,
            title,
        } = this.props;

        if (!title) {
            return null;
        }

        return (
            <title>
                {title ? title : default_title}
            </title>
        );
    }
}

export default MetaComponent;
